import { appVersion, devMapsApiKey, devStripeUrls } from './common-env-values';

export const environment = {
  production: false,
  apiUrl: 'https://dev.backend.pvsmartclick.com',
  version: appVersion,
  stripeUrls: devStripeUrls,
  mapsApiKey: devMapsApiKey,
};
